<div class="flex flex-col bg-ponder-light text-slate-50 rounded-t-md p-2 shadow">
    <div class="flex flex-row">
        <div id="card-name" class="grow">{{ getName(isTranslation) }}</div>
        @if (hasManaCost()) {
            <magic-card-mana-cost [manaCost]="getManaCost()!"></magic-card-mana-cost>
        }
    </div>
    @if (hasFlavorName()) {
        <div>
            {{ getFlavorName() }}
        </div>
    }
</div>
<div class="flex flex-col pl-2 pr-2 pb-1 pt-1 shadow-sm">
    <div class="flex flex-row">
        <div class="grow">{{ getTypeLine(isTranslation) }}</div>
        <magic-set-icon [setCode]="magicCard!.set!.code!" [rarity]="magicCard!.rarity"></magic-set-icon>
    </div>
</div>
@if (!isTranslation) {
    <div class="flex flex-col">
        <div #oracleTextbox class="pl-2 pr-1 pt-1 whitespace-pre-line" [innerHTML]="getText(false)! | magicmarkdown"></div>
        <div #flavorTextbox class="pl-2 pr-1 pt-2 pb-2 italic min-h-1 shadow-sm text-slate-500 text-sm" [innerHTML]="getFlavorText()! | magicmarkdown:false:true"></div>
        <div class="flex flex-row">
            @if (!isBackface) {
                <div class="pl-2 pr-1 pb-1 pt-1 text-sm shadow-sm grow">Art by <a [attr.href]="getArtistRoute()" class="text-ponder-link">{{ getArtistName() }}</a></div>
            }
            @if (hasPowerToughness()) {
                <div class="pl-2 pr-2 pt-1 pb-1 min-h-1 shadow-sm text-right">{{ getPowerToughness() }}</div>
            }
        </div>
        @if (!isBackface) {
            <div class="pl-2 pr-1 pb-1 pt-1 text-sm shadow-sm">{{ getReleaseDateStr() }} in <a href="/magic/set/{{ magicCard.set.code }}" class="text-ponder-link">{{ getSetName() }}</a></div>
        }
    </div>
} @else {
    <div class="flex flex-col">
        <div #oracleTextboxTranslation class="pl-2 pr-1 pb-1 whitespace-pre-line" [innerHTML]="getText(true)! | magicmarkdown"></div>
    </div>
}